import { min } from 'lodash';
import { useInfiniteHits } from 'react-instantsearch-hooks-web';
import { Button as MuiButton } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import type { ButtonProps } from '@mui/material';

const useStyles = makeStyles({ name: 'LoadInfiniteHits' })({
  buttonContainer: {
    display: 'flex',

    '& > button': {
      fontWeight: 400,
    },
  },
  buttonContainerLeft: {
    justifyContent: 'flex-start',
  },
  buttonContainerCenter: {
    justifyContent: 'center',
  },
});

export const LoadInfiniteHits: React.FC<ButtonProps & { align?: 'left' | 'center' }> = ({ align = 'left', ...restProps }) => {
  const { classes, cx } = useStyles();

  const {
    hits, showMore, results, isLastPage,
  } = useInfiniteHits();

  const { hitsPerPage, nbHits } = results;

  if (isLastPage) {
    return null;
  }

  const moreHitsNumber = min([hitsPerPage, nbHits - hits.length]);

  return (
    <div className={cx(classes.buttonContainer, align === 'center' ? classes.buttonContainerCenter : classes.buttonContainerLeft)}>
      <MuiButton
        variant="text"
        color="primary"
        {...restProps}
        onClick={showMore}
      >
        {`Load ${moreHitsNumber} more`}
      </MuiButton>
    </div>
  );
};
